import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/HeaderMain.css";
import ChoosePlans from "../app/payments/ChoosePlans";

function HeaderMain({ onBackToHome, isInStayInformedView }) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle clicking outside to close mobile menu
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handlePlanSelected = (plan) => {
    console.log("Plan selected:", plan);
    // Close the modal when a plan is selected
    setIsModalOpen(false);
    // You can add additional logic here to handle the selected plan
    // For example, redirect to a payment page or show a confirmation
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  const handleClick = (event) => {
    event.preventDefault();
    // Close mobile menu when a link is clicked
    setIsMobileMenuOpen(false);

    const linkClicked = event.currentTarget.getAttribute("href");

    // If we're in StayInformed view and user clicks navigation links, go back to main page first
    if (isInStayInformedView && linkClicked !== "#stayinformed") {
      if (onBackToHome) {
        onBackToHome();
      }
      // For non-stayinformed links, we'll handle the navigation after going back
      // We could add a timeout here if needed, but the page should update quickly
      if (
        linkClicked === "#home" ||
        linkClicked === "#pricing" ||
        linkClicked === "#events"
      ) {
        // These handle their own navigation
        setTimeout(() => {
          handleNavigation(linkClicked);
        }, 100);
        return;
      }
      // For scroll-based navigation, we'll scroll after the page updates
      setTimeout(() => {
        handleNavigation(linkClicked);
      }, 100);
      return;
    }

    // Handle normal navigation
    handleNavigation(linkClicked);
  };

  const handleNavigation = (linkClicked) => {
    // Adjust scroll position by the height of the header
    const headerElement = document.querySelector(".landing-header");
    const headerHeight = headerElement ? headerElement.offsetHeight : 0;
    let featuresSection = null;
    let topPosition = 0;

    switch (linkClicked) {
      case "#pricing":
        setIsModalOpen(true); // Open ChoosePlans modal
        break;
      case "#home":
        // Scroll to the very top of the page
        window.scrollTo({ top: 0, behavior: "smooth" });
        break;
      case "#events":
        navigate("/events");
        break;
      case "#features":
        featuresSection = document.querySelector(".landing-main20");
        if (featuresSection) {
          topPosition = featuresSection.offsetTop - headerHeight;
          window.scrollTo({ top: topPosition, behavior: "smooth" });
        }
        break;
      case "#faq":
        featuresSection = document.querySelector(".landing-main40");
        if (featuresSection) {
          topPosition = featuresSection.offsetTop - headerHeight;
          window.scrollTo({ top: topPosition, behavior: "smooth" });
        }
        break;
      case "#blogs":
        featuresSection = document.querySelector(".landing-page-blogs");
        if (featuresSection) {
          topPosition = featuresSection.offsetTop - headerHeight;
          window.scrollTo({ top: topPosition, behavior: "smooth" });
        }
        break;
      default:
        console.log("Navigation link not handled:", linkClicked);
        break;
      // Add more cases as needed
    }
  };
  return (
    <header className="landing-header">
      <div className="logo-container">
        <img
          src="/KinShield.png"
          alt="Logo"
          className="logo"
          draggable={false}
          onContextMenu={(e) => e.preventDefault()}
        />
        <span className="app-name">KinShield™</span>
      </div>

      {/* Hamburger Menu Button */}
      <button
        className={`hamburger-menu ${isMobileMenuOpen ? "active" : ""}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Desktop Navigation Links */}
      <nav className="nav-links desktop-only">
        <a href="#home" onClick={handleClick}>
          Home
        </a>
        <a href="#features" onClick={handleClick}>
          Features
        </a>
        <a href="#pricing" onClick={handleClick}>
          Pricing
        </a>
        <a href="#events" onClick={handleClick}>
          Events
        </a>
        <a href="#blogs" onClick={handleClick}>
          Blogs
        </a>
        <a href="#faq" onClick={handleClick}>
          FAQ
        </a>
      </nav>

      {/* Desktop Header Buttons */}
      <div className="header-buttons desktop-only">
        <button className="kinshield-app" onClick={() => navigate("/app")}>
          KinShield App
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}>
          <nav
            className="mobile-nav-main mobile-sidepanel-main"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mobile-sidepanel-main-content">
              {/* Navigation Links Section */}
              <div className="mobile-menu-section">
                <a href="#home" onClick={handleClick}>
                  Home
                </a>
                <a href="#features" onClick={handleClick}>
                  Features
                </a>
                <a href="#pricing" onClick={handleClick}>
                  Pricing
                </a>
                <a href="#events" onClick={handleClick}>
                  Events
                </a>
                <a href="#blogs" onClick={handleClick}>
                  Blogs
                </a>
                <a href="#faq" onClick={handleClick}>
                  FAQ
                </a>

                {/* Mobile Action Buttons */}
                <div className="mobile-buttons">
                  <button
                    className="kinshield-app mobile"
                    onClick={() => {
                      navigate("/app");
                      closeMobileMenu();
                    }}
                  >
                    KinShield App
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </div>
      )}

      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            margin: 0,
            padding: "10px",
            boxSizing: "border-box",
          }}
          onClick={closeModal}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "95vw",
              maxHeight: "95vh",
              width: "fit-content",
              height: "fit-content",
              overflow: "hidden",
              backgroundColor: "transparent",
              borderRadius: "8px",
              margin: 0,
              padding: 0,
              boxSizing: "border-box",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <ChoosePlans
              onCancel={closeModal}
              onPlanSelected={handlePlanSelected}
              onGoToApp={() => navigate("/app")}
            />
          </div>
        </div>
      )}
    </header>
  );
}

export default HeaderMain;
